export default "__VITE_ASSET__BUxh6S7k__"